import styled from "styled-components";

interface IContainer {
  isPointer: boolean;
}

export const Container = styled.button<IContainer>`
  border: 1px solid;
  padding: 14px;
  border-radius: 26px;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.68rem;
  color: ${(props) => props.theme.colors.brand1.pure};
  cursor: ${(props) => (props.isPointer ? "pointer" : "initial")};
  text-transform: uppercase;
  max-height: 50px;
  min-width: 150px;
  max-width: 150px;

  @media (min-width: 480px) {
    font-size: 0.89rem;
    min-width: 200px;
    max-width: 200px;
  }

  @media (min-width: 768px) {
    font-size: 0.68rem;
    padding: 10px 24px;
    min-height: 40px;
    max-width: 18em;
    max-height: 40px;
  }

  .filter_svg {
    margin-right:8px;
    width: 20px;
    height: 20px;

    @media (min-width: 768px) {
      min-width: 15px;
      height: 15px;
      margin:  0 12px 0 6px;
    }
  }

  .arrow_svg {
    margin: 0 8px;

    @media (min-width: 480px) {
      width: auto;
      height: auto;
    }

    @media (min-width: 768px) {
      width: auto;
      height: auto;
      // margin: 0 11px;
    }
  }

  > span {
    padding: 0 6px;
    color: ${(props) => props.theme.colors.typography2.dark};
    background-color: ${(props) => props.theme.colors.brand1.pure};
    margin-left: 8px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 0.78rem;
    line-height: 20px;

    @media (min-width: 480px) {
      padding: 2px 8px;
      margin-left: 16px;
    }

    @media (min-width: 768px) {
      font-size: 0.625rem;
      padding: 0 6px;
      margin-left: 5px;
    }
  }
`;
